import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const ADDRESS = "909/910, Akshat Tower, Near Pakwan Circle, Bodakdev, Ahmedabad - 380015";
const MAP_EMBED = "https://maps.google.com/maps?q=23.0372,72.5120&z=17&output=embed";

const ROWS = [
  { label: "Office:", value: `Parth Travels, ${ADDRESS} (Walk-in consultations welcome)` },
  { label: "Online:", value: "Pan-India ticketing, e-visas, and international package coordination" },
  { label: "Call:", value: "+91 92134 75305 · +91 98250 75692" },
  { label: "Hours:", value: "Monday to Saturday: 9:30 AM – 8:00 PM" },
];

export const ServiceArea = () => (
  <section className="py-20 bg-stone-50" data-testid="service-area-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="space-y-6"
        >
          <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Service Reach</span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 font-serif-display">
            Visit our office or plan remotely from anywhere in India
          </h2>
          <p className="text-stone-600 text-sm leading-relaxed">
            We operate one dedicated office where walk-in customers can sit with our travel consultants. We also serve clients across all Indian states and manage outbound international trips via phone and WhatsApp.
          </p>
          <div className="bg-white p-6 rounded-xl border border-stone-200 space-y-3">
            {ROWS.map((r) => (
              <div key={r.label} className="grid grid-cols-[72px_1fr] gap-3 items-baseline">
                <span className="text-amber-800 font-bold text-sm">{r.label}</span>
                <span className="text-sm text-stone-700 leading-relaxed">{r.value}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="aspect-[4/3] rounded-2xl border border-stone-300 relative overflow-hidden shadow-md"
          data-testid="map-embed"
        >
          <iframe
            title="Parth Travels office location — Akshat Tower, Bodakdev, Ahmedabad"
            src={MAP_EMBED}
            className="absolute inset-0 w-full h-full"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="absolute bottom-3 left-3 right-3 sm:right-auto bg-white/95 backdrop-blur rounded-lg px-3 py-2 shadow-md flex items-center gap-2 pointer-events-none">
            <MapPin className="w-4 h-4 text-amber-700 shrink-0" aria-hidden="true" />
            <span className="text-[11px] font-semibold text-stone-800 leading-tight">{ADDRESS}</span>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
